// gestion-vinos-frontend/src/config.js

const LOCAL_API_BASE_URL = "http://127.0.0.1:5000";
const PROD_API_BASE_URL = "https://salycome.com/api";

export const API_BASE_URL =
  process.env.NODE_ENV === "production" ? PROD_API_BASE_URL : LOCAL_API_BASE_URL;

export const STRIPE_PUBLIC_KEY ="pk_test_51Ot9xaIPuGo6t1su8iKb4uxeuBh5RXBiRxdJ71gwyGmByRNIn8NAZvNNWw2NhVuwZUbfQeKQtfYA1mjs9OhWpn9600isd3Ruui";
